import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  defaultUser: "/api/v1/registerCodes/internal",
};

export async function checkRegisterCode(code) {
  const requestUrl = BASE_URL + endpoints.defaultUser + "?code=" + code;

  try {
    var config = {
      method: "get",
      url: requestUrl,
      headers: {
        "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
      },
    };

    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}
